import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { Component, Input, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { TableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { TableColmuns } from 'src/app/interface/TableColumnsinterface';

@Component({
  selector: 'app-data-tabla',
  templateUrl: './data-tabla.component.html',
  styleUrl: './data-tabla.component.scss'
})
export class DataTablaComponent implements OnInit{

  @Input() selectedTabFinancieros: number=0;

  @Input() isKeymetrics: boolean = false;
  @Input() keymetrics: any;
  keyData = new TableVirtualScrollDataSource<any>();
  @ViewChild(CdkVirtualScrollViewport, { static: false })  keyMetricView!: CdkVirtualScrollViewport;
  displayedColumnsKey: string[] = [];
  tableColumnsKey: TableColmuns[]=[];

  @Input() isRatio: boolean = false;
  @Input() ratios: any;
  ratioData = new TableVirtualScrollDataSource<any>();
  @ViewChild(CdkVirtualScrollViewport, { static: false })  viewportRatio!: CdkVirtualScrollViewport;
  displayedColumnsRatio: string[] = [];
  tableColumnsRatio: TableColmuns[]=[]; 

  @Input() isCashflow: boolean = false;
  @Input() Cashflow: any;
  CashflowData = new TableVirtualScrollDataSource<any>();
  @ViewChild(CdkVirtualScrollViewport, { static: false })  viewportCashflow!: CdkVirtualScrollViewport;
  displayedColumnsCashflow: string[] = [];
  tableColumnsCashflow: TableColmuns[]=[];

  @Input() isIncomeGrowth: boolean = false;
  @Input() IncomeGrowth: any;
  IncomeGrowthData = new TableVirtualScrollDataSource<any>();
  @ViewChild(CdkVirtualScrollViewport, { static: false })  viewportIncomeGrowth: CdkVirtualScrollViewport;
  displayedColumnsIncomeGrowth: string[] = [];
  tableColumnsIncomeGrowth: TableColmuns[]=[];

  @Input() isBalanceSheetGrowth: boolean = false;
  @Input() BalanceSheetGrowth: any;
  BalanceSheetGrowthData = new TableVirtualScrollDataSource<any>();
  @ViewChild(CdkVirtualScrollViewport, { static: false })  viewportBalanceSheetGrowth: CdkVirtualScrollViewport;
  displayedColumnsBalanceSheetGrowth: string[] = [];
  tableColumnsBalanceSheetGrowth: TableColmuns[]=[];

  @Input() isFinancialGrowth: boolean = false;
  @Input() FinancialGrowth: any;
  FinancialGrowthData = new TableVirtualScrollDataSource<any>();
  @ViewChild(CdkVirtualScrollViewport, { static: false })  viewportFinancialGrowth: CdkVirtualScrollViewport;
  displayedColumnsFinancialGrowth: string[] = [];
  tableColumnsFinancialGrowth: TableColmuns[]=[];

  @Input() isOwnerEarnings: boolean = false;
  @Input() OwnerEarnings: any;
  OwnerEarningsData = new TableVirtualScrollDataSource<any>();
  @ViewChild(CdkVirtualScrollViewport, { static: false })  viewportFinancialScore: CdkVirtualScrollViewport;
  displayedColumnsOwnerEarnings: string[] = [];
  tableColumnsOwnerEarnings: TableColmuns[]=[];
  //EnterpriseValues
  @Input() isEnterpriseValues: boolean = false;
  @Input() EnterpriseValues: any;
  EnterpriseValuesData = new TableVirtualScrollDataSource<any>();
  @ViewChild(CdkVirtualScrollViewport, { static: false })  viewportEnterpriseValues: CdkVirtualScrollViewport;
  displayedColumnsEnterpriseValues: string[] = [];
  tableColumnsEnterpriseValues: TableColmuns[]=[];

  panelOpenState: boolean=false;
  colPanelOpen = false;
  expandirColPanel() { this.colPanelOpen = true; }
  contraerColPanel() { this.colPanelOpen = false; }

  ngOnInit(): void {
    this.actualizarViewport();
  
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes['selectedTabFinancieros']){
      this.actualizarViewport();
    }
    if (changes['ratios']) {
      this.cargarRatio();
    }else if(changes['keymetrics']){
      this.cargarKey();
    }else if(changes['Cashflow']){
      this.cargarCashflow();
    }else if(changes['IncomeGrowth']){
      this.cargarIncomeGrowth();
    }else if(changes['BalanceSheetGrowth']){
      this.cargarBalanceSheetGrowth();
    }else if(changes['FinancialGrowth']){
      this.cargarFinancialGrowth();
    }else if(changes['OwnerEarnings']){
      this.cargarOwnerEarnings();
    }else if (changes['EnterpriseValues']){
      this.cargarEnterpriseValues();
    }
  }

  titulo(input: string): string {
    return input
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase()) 
      .trim(); 
  }
  
 
  isDateValue(value: any): boolean {
    return value instanceof Date && !isNaN(value.valueOf());
  }

  toggleColumnVisibility(id: any, tipo: string){
    if(tipo =='ratio'){
      const column = this.tableColumnsRatio.find(col => col.id === id);
      if (column) {
        column.isShow = !column.isShow;
        this.displayedColumnsRatio = this.tableColumnsRatio.filter(col => col.isShow).map(col => col.id);
      }
    }else if(tipo =='keymetric'){
      const column = this.tableColumnsKey.find(col => col.id === id);
      if (column) {
        column.isShow = !column.isShow;
        this.displayedColumnsKey = this.tableColumnsKey.filter(col => col.isShow).map(col => col.id);
      }
    }else if(tipo =='Cashflow'){
      const column = this.tableColumnsCashflow.find(col => col.id === id);
      if (column) {
        column.isShow = !column.isShow;
        this.displayedColumnsCashflow = this.tableColumnsCashflow.filter(col => col.isShow).map(col => col.id);
      }
    }else if(tipo =='IncomeGrowth'){
      const column = this.tableColumnsIncomeGrowth.find(col => col.id === id);
      if (column) {
        column.isShow = !column.isShow;
        this.displayedColumnsIncomeGrowth = this.tableColumnsIncomeGrowth.filter(col => col.isShow).map(col => col.id);
      }
    }else if(tipo =='BalanceSheetGrowth'){
      const column = this.tableColumnsBalanceSheetGrowth.find(col => col.id === id);
      if (column) {
        column.isShow = !column.isShow;
        this.displayedColumnsBalanceSheetGrowth = this.tableColumnsBalanceSheetGrowth.filter(col => col.isShow).map(col => col.id);
    }
    }else if(tipo == 'FinancialGrowth'){
      const column = this.tableColumnsFinancialGrowth.find(col => col.id === id);
      if (column) {
        column.isShow = !column.isShow;
        this.displayedColumnsFinancialGrowth = this.tableColumnsFinancialGrowth.filter(col => col.isShow).map(col => col.id);
    }
    }else if(tipo == 'OwnerEarnings'){
      const column = this.tableColumnsOwnerEarnings.find(col => col.id === id);
      if (column) {
        column.isShow = !column.isShow;
        this.displayedColumnsOwnerEarnings = this.tableColumnsOwnerEarnings.filter(col => col.isShow).map(col => col.id);
    }
    }else if(tipo=='EnterpriseValues'){
      const column = this.tableColumnsEnterpriseValues.find(col => col.id === id);
      if (column) {
        column.isShow = !column.isShow;
        this.displayedColumnsEnterpriseValues = this.tableColumnsEnterpriseValues.filter(col => col.isShow).map(col => col.id);
    }
    }

  }

  actualizarViewport() {
    if (this.viewportRatio) {
  
      this.viewportRatio.checkViewportSize();
      this.viewportRatio.checkViewportSize();
    }if (this.keyMetricView) {
      this.keyMetricView.checkViewportSize();
      this.keyMetricView.checkViewportSize();

    }if (this.viewportCashflow) {

      this.viewportCashflow.checkViewportSize();
      this.viewportCashflow.checkViewportSize();
    }if (this.viewportIncomeGrowth) {

      this.viewportIncomeGrowth.checkViewportSize();
      this.viewportIncomeGrowth.checkViewportSize();
    }if(this.viewportBalanceSheetGrowth){

      this.viewportBalanceSheetGrowth.checkViewportSize();
      this.viewportBalanceSheetGrowth.checkViewportSize();
    }if(this.viewportFinancialGrowth){
      this.viewportFinancialGrowth.checkViewportSize();
      this.viewportFinancialGrowth.checkViewportSize();
    }if(this.viewportFinancialScore){
      this.viewportFinancialScore.checkViewportSize();
      this.viewportFinancialScore.checkViewportSize();
    }if(this.viewportEnterpriseValues){
      this.viewportEnterpriseValues.checkViewportSize();
      this.viewportEnterpriseValues.checkViewportSize();
    }
  }

  cargarRatio(){
    if(this.tableColumnsRatio){
      this.displayedColumnsRatio = [];
      this.tableColumnsRatio = [];
    }
    if (this.ratios) {
      this.ratioData.data=this.ratios;
      if (this.ratios.length > 0) {
        this.displayedColumnsRatio = Object.keys(this.ratios[0]);
      }
      if (this.ratios && this.ratios.length > 0) {
        const keys = Object.keys(this.ratios[0]);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          const isDate = this.isDateValue(this.ratios[0][key]);
          const isNumber = typeof this.ratios[0][key] === 'number' && !isNaN(this.ratios[0][key]);

          const isString = typeof this.ratios[0][key] === 'string';
          let data:boolean ;
          if(i < 10){
            data=true;
          }else{ data = false}

      
          this.tableColumnsRatio.push({
            id: key,
            name: this.titulo(key), 
            isShow: data,
            isDate: isDate,
            isNumber: isNumber,
            isString: isString
          });
      
        }
        const visibleColumns = this.tableColumnsRatio.filter(column => column.isShow);
        this.displayedColumnsRatio = visibleColumns.map(column => column.id);
      }
      
    }
  }

  cargarKey(){
    if(this.displayedColumnsKey){
      this.displayedColumnsKey= [];
      this.tableColumnsKey=[];
    }
    if (this.keymetrics) {
      this.keyData.data=this.keymetrics;
      if (this.keymetrics.length > 0) {
        this.displayedColumnsKey = Object.keys(this.keymetrics[0]);
      }
      if (this.keymetrics && this.keymetrics.length > 0) {
        const keys = Object.keys(this.keymetrics[0]);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          const isDate = this.isDateValue(this.keymetrics[0][key]); //linea 125
          const isNumber = typeof this.keymetrics[0][key] === 'number' && !isNaN(this.keymetrics[0][key]);

          const isString = typeof this.keymetrics[0][key] === 'string';
          let data:boolean ;
          if(i < 10){
            data=true;
          }else{ data = false}

      
          this.tableColumnsKey.push({
            id: key,
            name: this.titulo(key), 
            isShow: data,
            isDate: isDate,
            isNumber: isNumber,
            isString: isString
          });
      
        }
        const visibleColumns = this.tableColumnsKey.filter(column => column.isShow);
        this.displayedColumnsKey = visibleColumns.map(column => column.id);
      }

    }
  }

  cargarCashflow(){
    if(this.displayedColumnsCashflow){
      this.displayedColumnsCashflow= [];
      this.tableColumnsCashflow=[];
    }
    if (this.Cashflow) {
      this.CashflowData.data=this.Cashflow;
      if (this.Cashflow.length > 0) {
        this.displayedColumnsCashflow = Object.keys(this.Cashflow[0]);
      }
      if (this.Cashflow && this.Cashflow.length > 0) {
        const keys = Object.keys(this.Cashflow[0]);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          const isDate = this.isDateValue(this.Cashflow[0][key]); //linea 125
          const isNumber = typeof this.Cashflow[0][key] === 'number' && !isNaN(this.Cashflow[0][key]);

          const isString = typeof this.Cashflow[0][key] === 'string';
          let data:boolean ;
          if(i < 10){
            data=true;
          }else{ data = false}

      
          this.tableColumnsCashflow.push({
            id: key,
            name: this.titulo(key), 
            isShow: data,
            isDate: isDate,
            isNumber: isNumber,
            isString: isString
          });
      
        }
        const visibleColumns = this.tableColumnsCashflow.filter(column => column.isShow);
        this.displayedColumnsCashflow = visibleColumns.map(column => column.id);
      }
    }
  }

  
  cargarIncomeGrowth(){
    if(this.displayedColumnsIncomeGrowth){
      this.displayedColumnsIncomeGrowth= [];
      this.tableColumnsIncomeGrowth=[];
    }
    if (this.IncomeGrowth) {
      this.IncomeGrowthData.data=this.IncomeGrowth;
      if (this.IncomeGrowth.length > 0) {
        this.displayedColumnsIncomeGrowth = Object.keys(this.IncomeGrowth[0]);
      }
      if (this.IncomeGrowth && this.IncomeGrowth.length > 0) {
        const keys = Object.keys(this.IncomeGrowth[0]);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          const isDate = this.isDateValue(this.IncomeGrowth[0][key]); //linea 125
          const isNumber = typeof this.IncomeGrowth[0][key] === 'number' && !isNaN(this.IncomeGrowth[0][key]);

          const isString = typeof this.IncomeGrowth[0][key] === 'string';
          let data:boolean ;
          if(i < 10){
            data=true;
          }else{ data = false}

      
          this.tableColumnsIncomeGrowth.push({
            id: key,
            name: this.titulo(key), 
            isShow: data,
            isDate: isDate,
            isNumber: isNumber,
            isString: isString
          });
      
        }
        const visibleColumns = this.tableColumnsIncomeGrowth.filter(column => column.isShow);
        this.displayedColumnsIncomeGrowth = visibleColumns.map(column => column.id);
      }
      
    }

  }

  cargarBalanceSheetGrowth(){
    if(this.displayedColumnsBalanceSheetGrowth){
      this.displayedColumnsBalanceSheetGrowth= [];
      this.tableColumnsBalanceSheetGrowth=[];
    }
    if (this.BalanceSheetGrowth) {
      this.BalanceSheetGrowthData.data=this.BalanceSheetGrowth;
      if (this.BalanceSheetGrowth.length > 0) {
        this.displayedColumnsBalanceSheetGrowth = Object.keys(this.BalanceSheetGrowth[0]);
      }
      if (this.BalanceSheetGrowth && this.BalanceSheetGrowth.length > 0) {
        const keys = Object.keys(this.BalanceSheetGrowth[0]);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          const isDate = this.isDateValue(this.BalanceSheetGrowth[0][key]); //linea 125
          const isNumber = typeof this.BalanceSheetGrowth[0][key] === 'number' && !isNaN(this.BalanceSheetGrowth[0][key]);

          const isString = typeof this.BalanceSheetGrowth[0][key] === 'string';
          let data:boolean ;
          if(i < 10){
            data=true;
          }else{ data = false}

      
          this.tableColumnsBalanceSheetGrowth.push({
            id: key,
            name: this.titulo(key), 
            isShow: data,
            isDate: isDate,
            isNumber: isNumber,
            isString: isString
          });
      
        }
        const visibleColumns = this.tableColumnsBalanceSheetGrowth.filter(column => column.isShow);
        this.displayedColumnsBalanceSheetGrowth = visibleColumns.map(column => column.id);
      }

    }

  }

  cargarFinancialGrowth(){
    if(this.displayedColumnsFinancialGrowth){
      this.displayedColumnsFinancialGrowth= [];
      this.tableColumnsFinancialGrowth=[];
    }
    if (this.FinancialGrowth) {
      this.FinancialGrowthData.data=this.FinancialGrowth;
      if (this.FinancialGrowth.length > 0) {
        this.displayedColumnsFinancialGrowth = Object.keys(this.FinancialGrowth[0]);
      }
      if (this.FinancialGrowth && this.FinancialGrowth.length > 0) {
        const keys = Object.keys(this.FinancialGrowth[0]);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          const isDate = this.isDateValue(this.FinancialGrowth[0][key]); //linea 125
          const isNumber = typeof this.FinancialGrowth[0][key] === 'number' && !isNaN(this.FinancialGrowth[0][key]);

          const isString = typeof this.FinancialGrowth[0][key] === 'string';
          let data:boolean ;
          if(i < 10){
            data=true;
          }else{ data = false}

      
          this.tableColumnsFinancialGrowth.push({
            id: key,
            name: this.titulo(key), 
            isShow: data,
            isDate: isDate,
            isNumber: isNumber,
            isString: isString
          });
      
        }
        const visibleColumns = this.tableColumnsFinancialGrowth.filter(column => column.isShow);
        this.displayedColumnsFinancialGrowth = visibleColumns.map(column => column.id);
      }
    }

  }
  cargarOwnerEarnings(){
    if(this.displayedColumnsOwnerEarnings){
      this.displayedColumnsOwnerEarnings= [];
      this.tableColumnsOwnerEarnings=[];
    }
    if (this.OwnerEarnings) {
      this.OwnerEarningsData.data=this.OwnerEarnings;
      if (this.OwnerEarnings.length > 0) {
        this.displayedColumnsOwnerEarnings = Object.keys(this.OwnerEarnings[0]);
      }
      if (this.OwnerEarnings && this.OwnerEarnings.length > 0) {
        const keys = Object.keys(this.OwnerEarnings[0]);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          const isDate = this.isDateValue(this.OwnerEarnings[0][key]); //linea 125
          const isNumber = typeof this.OwnerEarnings[0][key] === 'number' && !isNaN(this.OwnerEarnings[0][key]);

          const isString = typeof this.OwnerEarnings[0][key] === 'string';
          let data:boolean ;
          if(i < 10){
            data=true;
          }else{ data = false}

      
          this.tableColumnsOwnerEarnings.push({
            id: key,
            name: this.titulo(key), 
            isShow: data,
            isDate: isDate,
            isNumber: isNumber,
            isString: isString
          });
      
        }
        const visibleColumns = this.tableColumnsOwnerEarnings.filter(column => column.isShow);
        this.displayedColumnsOwnerEarnings = visibleColumns.map(column => column.id);
      }
      
    }

  }
  cargarEnterpriseValues(){
    if(this.displayedColumnsEnterpriseValues){
      this.displayedColumnsEnterpriseValues= [];
      this.tableColumnsEnterpriseValues=[];
    }
    if (this.EnterpriseValues) {
      this.EnterpriseValuesData.data=this.EnterpriseValues;
      if (this.EnterpriseValues.length > 0) {
        this.displayedColumnsEnterpriseValues = Object.keys(this.EnterpriseValues[0]);
      }
      if (this.EnterpriseValues && this.EnterpriseValues.length > 0) {
        const keys = Object.keys(this.EnterpriseValues[0]);
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i];
          const isDate = this.isDateValue(this.EnterpriseValues[0][key]); //linea 125
          const isNumber = typeof this.EnterpriseValues[0][key] === 'number' && !isNaN(this.EnterpriseValues[0][key]);

          const isString = typeof this.EnterpriseValues[0][key] === 'string';
          let data:boolean ;
          if(i < 10){
            data=true;
          }else{ data = false}

      
          this.tableColumnsEnterpriseValues.push({
            id: key,
            name: this.titulo(key), 
            isShow: data,
            isDate: isDate,
            isNumber: isNumber,
            isString: isString
          });
      
        }
        const visibleColumns = this.tableColumnsEnterpriseValues.filter(column => column.isShow);
        this.displayedColumnsEnterpriseValues = visibleColumns.map(column => column.id);
      }
      
      console.log("displayedColumnsFinancialGrowth: ", this.displayedColumnsEnterpriseValues);
      console.log("keyData FinancialGrowthData: ",this.EnterpriseValuesData);
      console.log("XXXXXX tableColumnsFinancialGrowth", this.tableColumnsEnterpriseValues);
    }

  }

}
